(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["al-video-section"] && !Shopify.designMode) return;
  try {
    
(function () {
  var videos = document.querySelectorAll('.al-vid-section__video[data-src]');
  if (!videos.length) return;

  var reduceData = false;
  try {
    reduceData = (navigator.connection && navigator.connection.saveData) ||
      window.matchMedia('(prefers-reduced-data: reduce)').matches;
  } catch (e) {}

  function activate(video) {
    var src = video.getAttribute('data-src');
    if (!src) return;
    video.src = src;
    video.removeAttribute('data-src');
    if (video.hasAttribute('data-autoplay') && !reduceData) {
      video.play().catch(function () {});
    }
  }

  if (reduceData) {
    // Data-saver / reduced-data users: attach the file so native controls work,
    // but never auto-fetch ahead of scroll and never autoplay.
    videos.forEach(function (video) {
      video.setAttribute('controls', '');
      video.preload = 'metadata';
      activate(video);
    });
    return;
  }

  if (!('IntersectionObserver' in window)) {
    videos.forEach(activate);
    return;
  }

  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        activate(entry.target);
        observer.unobserve(entry.target);
      }
    });
  }, { rootMargin: '200px 0px' });

  videos.forEach(function (video) {
    observer.observe(video);
  });
})();

  } catch(e) { console.error(e); }
})();
})();
